import { Filters } from '../components/TrackerManager/Filter/FilterTreeFunctions';
import type { ManagedTracker } from '../store/trackers/trackers_reducers';

const addUserWithRole = (
  userId: string,
  role: string,
  filteredUserIds: Array<string>,
  usersWithRoles: Set<string>,
) => {
  if (filteredUserIds.includes(userId)) {
    usersWithRoles.add(userId);
    usersWithRoles.add(`${userId}/${role}`);
  }
};

export const getUserFilterCounts = (
  filterCounts: Map<Filters, Map<string, number>>,
  tracker: ManagedTracker,
  filteredUserIds: Array<string>,
) => {
  const userFilterCounts = filterCounts.get(Filters.Users) || new Map<string, number>();
  const usersWithRoles = new Set<string>();

  tracker.borrowers.forEach((borrower) =>
    addUserWithRole(borrower.id.toHexString(), 'borrower', filteredUserIds, usersWithRoles),
  );
  tracker.editors.forEach((editor) =>
    addUserWithRole(editor.toHexString(), 'editor', filteredUserIds, usersWithRoles),
  );
  addUserWithRole(tracker.owner.toHexString(), 'owner', filteredUserIds, usersWithRoles);

  usersWithRoles.forEach((userWithRole) => {
    userFilterCounts.set(userWithRole, (userFilterCounts.get(userWithRole) || 0) + 1);
  });

  return userFilterCounts;
};
